// extracted by mini-css-extract-plugin
export default {"scroll-down":"ScrollDown_scroll-down__-KEJx","scroll-span":"ScrollDown_scroll-span__sGSV0","animate":"ScrollDown_animate__hyTAN","animatex":"ScrollDown_animatex__8orGt"};